import {
  Chip,
  List,
  ListDivider,
  ListItem,
  Option,
  Select,
  Stack,
  Typography,
} from "@mui/joy";
import groupBy from "lodash/groupBy";
import { Fragment, memo, useMemo } from "react";
import { type AudienceSeedOption } from "features/mediaDataRoom/models";

interface AudienceSelectorProps {
  chipText?: string;
  seedOptions: AudienceSeedOption[];
  onSelect: (audience: AudienceSeedOption | null) => void;
  testId?: string;
  value: string | null;
}
const AudienceSelector = memo<AudienceSelectorProps>(
  ({ chipText, seedOptions, onSelect, testId, value }) => {
    const groupedSeedOptions = useMemo(
      () => Object.entries(groupBy(seedOptions, "group")),
      [seedOptions]
    );
    return (
      <Stack alignItems="center" direction="row" gap={1} mt={1}>
        {chipText ? (
          <Chip data-testid="audience-chip" size="lg">
            {chipText}
          </Chip>
        ) : null}
        <Select
          id={testId || "audience-select"}
          onChange={(_, value) =>
            onSelect(seedOptions.find((config) => config.id === value) || null)
          }
          placeholder="Select an audience"
          sx={{ flex: 1 }}
          value={value}
        >
          {groupedSeedOptions.map(([group, options], index) => (
            <Fragment key={group}>
              {index !== 0 && <ListDivider role="none" />}
              <List aria-labelledby={`select-group-${group}`}>
                <ListItem id={`select-group-${group}`} sticky={true}>
                  <Typography level="body-xs">{group}</Typography>
                </ListItem>
                {options.map(({ id, name }) => (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                ))}
              </List>
            </Fragment>
          ))}
        </Select>
      </Stack>
    );
  }
);

AudienceSelector.displayName = "AudienceSelector";

export default AudienceSelector;
